import './App.css';
import './style.bundle.css';
import './assets/plugins/plugins.bundle.css';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { listen } from './redux/listener';
import {  FE_BASE_URL, isTokenExpired } from './config';
import AppRoutes from './routes';

function App() {
  const navigate = useNavigate();

  useEffect(() => {
    listen();
    const checkToken = async () => {
      const token = localStorage.getItem('access_token');
      const currentPath = window.location.pathname;

      if (
        (!token || isTokenExpired(token)) &&
        currentPath !== '/' // sesuaikan dengan path login Anda
      ) {
        localStorage.removeItem('access_token');
        localStorage.removeItem('orderItems');
        localStorage.removeItem('patients');
        localStorage.removeItem('workers');
        window.location.href = `${FE_BASE_URL}`; // arahkan ke halaman login
        return;
      }
      
    };
    checkToken();
  },[navigate]);
  
  return (
      <AppRoutes />
  );
}

export default App;
